import React from "react";
import { styleOptions } from "~/utils/quiz/questionsData";
import {
  getWineStylesByColor,
  RED_WINE_COLOR_THRESHOLD,
  WHITE_WINE_COLOR_THRESHOLD,
} from "~/utils/quiz/questions";
import { RatingQuestion } from "../RatingQuestion";

export function StylesQuestionWrapper({
  answerValue,
  colorAnswer,
  quizQuestionText,
  onFinish,
  onChangeValue,
}) {
  let options = styleOptions;

  if (colorAnswer >= RED_WINE_COLOR_THRESHOLD) {
    options = getWineStylesByColor();
  } else if (colorAnswer <= WHITE_WINE_COLOR_THRESHOLD) {
    options = getWineStylesByColor("white");
  }

  const onChange = (value) => {
    // we need to pass all the values not just the ones filtered by color
    const valueIds = value.map(v => v.id);
    const rest = answerValue.filter( ans => !valueIds.includes(ans.id));
    onChangeValue([...rest, ...value]);
  }

  return (
    <RatingQuestion
      options={options}
      answerValue={answerValue}
      quizStepId="styles"
      quizQuestionText={quizQuestionText}
      onChangeValue={onChange}
      onFinish={onFinish}
    />
  );
}
